import { PropertyManagementSystem } from "types/landlord/partner";
import { SupportedPropertyManagementSystem } from "utils/supportedPMS";
import { PMSNames } from "views/settings-developers/constants";

type Option = {
  value: string;
  label: string;
};

export const PMS: Option[] = [
  ...SupportedPropertyManagementSystem.map((pms) => ({
    value: String(pms),
    label: PMSNames[pms]
  })),
  {
    value: String(PropertyManagementSystem.OTHER),
    label: PMSNames[PropertyManagementSystem.OTHER]
  },
  {
    value: "",
    label: "No software"
  }
];

export enum FirstFormKeys {
  FIRST_NAME = "first_name",
  LAST_NAME = "last_name",
  EMAIL = "email",
  PASSWORD = "password",
  PHONE = "phone"
}
